import Content from '../components/Content';
import AutomationStore from '../stores/AutomationStore';
import CreateAutomationPushes from '../components/automation/CreateAutomationPushes';

const AutomationPushes = ({userStore}) => {
  const myAutomationStore = new AutomationStore(userStore);

  return (
    <Content title="Interações com usuários fictícios" userStore={userStore}>
      <CreateAutomationPushes automationStore={myAutomationStore} />
    </Content>
  )
}

export default AutomationPushes
